import { useParams, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, type System } from '../lib/api';
import LoadingSpinner from '../components/LoadingSpinner';

/**
 * Legacy /:sys/pay route. The Pay flow merged into PayRunDetail; this is
 * just a redirect to the open run for any old bookmarks. If no run is open,
 * land on the Pay Runs list where the user can see they need to import a
 * file (which auto-opens a run).
 */
export default function Pay() {
  const { sys: sysSlug } = useParams<{ sys: string }>();
  const sys = sysSlug === 'messer' ? 'Messer' : sysSlug === 'empire-aca' ? 'Empire-ACA' : null;

  const runsQuery = useQuery({
    queryKey: ['pay-runs', sys],
    queryFn: () => api.listPayRuns(sys as System),
    enabled: !!sys,
  });

  if (!sys) return <div className="alert alert-warning"><p>Pick a system.</p></div>;
  if (runsQuery.isLoading) return <LoadingSpinner label="Looking for an open pay run…" />;

  const openRun = runsQuery.data?.pay_runs.find((r) => r.status === 'open') ?? null;
  if (openRun) {
    return <Navigate to={`/${sysSlug}/pay-runs/${openRun.pay_run_id}`} replace />;
  }
  return <Navigate to={`/${sysSlug}/pay-runs`} replace />;
}
